export default __webpack_public_path__ + "static/media/welcome_bg.0c13c67f.png";